/**
 * lanesFilterFields.js
 *
 * Advanced filter field catalog for the Lanes grid. Field keys and operators match
 * LaneDynamicSpecification.java's leaf handling on the backend field-for-field.
 */

const TEXT_OPS = ["CONTAINS", "EQ"];

export const LANE_FACILITY_TYPE_OPTIONS = ["GEOGRAPHY", "POINT", "WAREHOUSE"];

export const LANE_RULE_FIELDS = [
  {
    key: "laneCode", label: "Lane Code", type: "text", group: "Lane",
    ops: TEXT_OPS, backendField: "laneCode", placeholder: "e.g. LN-00123",
  },
  { key: "name", label: "Name", type: "text", group: "Lane", ops: TEXT_OPS, backendField: "name" },
  {
    key: "officeCode", label: "Office Code", type: "text", group: "Lane",
    ops: TEXT_OPS, backendField: "officeCode", placeholder: "e.g. DIAMOND-MET",
  },
  {
    key: "contractCode", label: "Contract Code", type: "text", group: "Lane",
    ops: TEXT_OPS, backendField: "contractCode",
  },

  { key: "origin", label: "Origin", type: "text", group: "Origin", ops: TEXT_OPS, backendField: "origin" },
  { key: "originCountry", label: "Origin Country", type: "text", group: "Origin", ops: TEXT_OPS, backendField: "originCountry" },
  { key: "originState", label: "Origin State", type: "text", group: "Origin", ops: TEXT_OPS, backendField: "originState" },
  { key: "originCity", label: "Origin City", type: "text", group: "Origin", ops: TEXT_OPS, backendField: "originCity" },
  {
    key: "originType", label: "Origin Facility Type", type: "select", group: "Origin",
    options: LANE_FACILITY_TYPE_OPTIONS, ops: ["EQ", "NEQ"], backendField: "originType",
  },

  { key: "destination", label: "Destination", type: "text", group: "Destination", ops: TEXT_OPS, backendField: "destination" },
  { key: "destinationCountry", label: "Destination Country", type: "text", group: "Destination", ops: TEXT_OPS, backendField: "destinationCountry" },
  { key: "destinationState", label: "Destination State", type: "text", group: "Destination", ops: TEXT_OPS, backendField: "destinationState" },
  { key: "destinationCity", label: "Destination City", type: "text", group: "Destination", ops: TEXT_OPS, backendField: "destinationCity" },
  {
    key: "destinationType", label: "Destination Facility Type", type: "select", group: "Destination",
    options: LANE_FACILITY_TYPE_OPTIONS, ops: ["EQ", "NEQ"], backendField: "destinationType",
  },
];
